"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.blockchainBaseURL = exports.getCurrencyExplorer = exports.findCurrencyExplorer = void 0;
var invariant_1 = __importDefault(require("invariant"));
var env_1 = require("../env");
var findCurrencyExplorer = function (currency) {
    var _a;
    if ((0, env_1.getEnv)("SATSTACK") && currency.id === "bitcoin") {
        return {
            endpoint: (0, env_1.getEnv)("EXPLORER_SATSTACK"),
            id: "btc",
            version: "v3"
        };
    }
    if (currency.explorerId == null) {
        console.warn("no explorerId for", currency.id);
    }
    return {
        endpoint: (0, env_1.getEnv)("EXPLORER"),
        id: (_a = currency.explorerId) !== null && _a !== void 0 ? _a : currency.id,
        version: "v4"
    };
};
exports.findCurrencyExplorer = findCurrencyExplorer;
var getCurrencyExplorer = function (currency) {
    var res = (0, exports.findCurrencyExplorer)(currency);
    (0, invariant_1["default"])(res, "no Ledger explorer for ".concat(currency.id));
    return res;
};
exports.getCurrencyExplorer = getCurrencyExplorer;
var blockchainBaseURL = function (currency) {
    var _a = (0, exports.getCurrencyExplorer)(currency), id = _a.id, version = _a.version, endpoint = _a.endpoint;
    return "".concat(endpoint, "/blockchain/").concat(version, "/").concat(id);
};
exports.blockchainBaseURL = blockchainBaseURL;
//# sourceMappingURL=Ledger.js.map